import React from 'react';
import { ExternalLink, FileText, Loader2 } from 'lucide-react';
import './TimberPdfPreviewPanel.css';

export type TimberPdfPreviewPanelProps = {
  supplierName: string;
  speciesSummary: string;
  drynessSummary: string;
  html: string | null;
  loading?: boolean;
  error?: string | null;
  onOpenFullPreview?: () => void;
  disabled?: boolean;
};

const TimberPdfPreviewPanel: React.FC<TimberPdfPreviewPanelProps> = ({
  supplierName,
  speciesSummary,
  drynessSummary,
  html,
  loading = false,
  error = null,
  onOpenFullPreview,
  disabled = false,
}) => {
  return (
    <section className="tppt" aria-labelledby="tppt-heading">
      <div className="tppt-head">
        <div className="tppt-file">
          <FileText size={18} aria-hidden className="tppt-file-icon" />
          <div>
            <h3 id="tppt-heading" className="tppt-title">Timber PDF preview</h3>
            <p className="tppt-sub">
              Request-for-quote PDF for <strong>{supplierName}</strong>
              {speciesSummary ? <> · {speciesSummary}</> : null}
              {drynessSummary ? <> · {drynessSummary}</> : null}
            </p>
          </div>
        </div>
        {onOpenFullPreview && (
          <button
            type="button"
            className="tppt-open-btn"
            disabled={disabled || loading || !html}
            onClick={onOpenFullPreview}
          >
            <ExternalLink size={14} aria-hidden />
            Open full PDF
          </button>
        )}
      </div>

      {loading && (
        <div className="tppt-loading" role="status">
          <Loader2 size={18} className="tppt-spin" aria-hidden />
          Building PDF preview…
        </div>
      )}

      {error && !loading && (
        <p className="tppt-banner tppt-banner--error" role="alert">
          {error}
        </p>
      )}

      {!loading && !error && html && (
        <div className="tppt-frame-wrap">
          <iframe
            className="tppt-frame"
            title={`Timber RFQ PDF preview for ${supplierName}`}
            srcDoc={html}
            sandbox="allow-same-origin"
          />
        </div>
      )}
    </section>
  );
};

export default TimberPdfPreviewPanel;
